module.exports = require("./doi");